
import React from 'react'
import './responsedisplay.css'
import { Delete, Check, Cancel} from "@mui/icons-material"
import StatusContext from '../../../contexts/StatusContext'
import MarkdownResponseDisplay from '../markdown/MarkdownResponseDisplay';
import { CopyTextIcon } from '../customicons/CopyTextIcon';
import { ButtonAIProvider } from '../buttonaiprovider/ButtonAIProvider';


export const ResponseDisplayTemplates = ({ displayprompt, onDeletePrompt, onCancelDelete, onAcceptDelete }) => {
  let {
    isLoading,
    } = React.useContext(StatusContext); 

 
  return (
    <div disabled={isLoading} >
      {
        <div key={displayprompt.id}>
          {
          <>
            <div className="promptTextPromp" >
           
           <div className="flex-container">
            
              {
            
                (displayprompt.delete === true) ?
                  <>
                   <Check className="promptIconColored"  onClick={() => { !isLoading && onAcceptDelete(displayprompt)}} />
                   <Cancel className="promptIconColored"  onClick={() => { !isLoading && onCancelDelete(displayprompt) }} />
                  </>
                  : 
                  <Delete className="promptIconColored"  onClick={() => { !isLoading && onDeletePrompt(displayprompt) }} />
               } 
            

            {
              <CopyTextIcon prompt={displayprompt} />
            }
            {    
              displayprompt.aiprovider &&
                <ButtonAIProvider provider={displayprompt.aiprovider} model={displayprompt.ainame}/>
            }
         
            </div>
           
           
            <MarkdownResponseDisplay text={displayprompt.response} />    
         
             
            </div>
           
            <hr className='separator'></hr>

            </>
          
          }
        </div>
      }
    </div>
  )
  
}


ResponseDisplayTemplates.defaultProps = {
  showprompts: true
};

export default ResponseDisplayTemplates
